<template>
    <v-container fluid class="px-0 pt-16 px-md-1">
        <div v-if="showcargando == true" id="cargando" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos.
            </p>
        </div>
        <div class="tables-basic mt-3">

        </div>
        <!--<Cambio cleinte />-->
        <v-row v-if="cambioCli">
            <v-col lg=12 cols=12 style="margin: 0 auto;">
                <v-card class=" mx-1 pt-3" v-if="mostrar">
                    <v-card-title class="pa-5 pb-3 primary">
                        <v-icon class="pr-3" color="white">mdi-account-reactivate-outline</v-icon>
                        <p style="color: white;">Cambio de Aseguradora</p>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-card-text class="pa-5 pt-4">
                        <v-row align="center">
                            <v-col class="" cols="12" sm="6">
                                <label class="typo__label">Aseguradora</label>
                                <multiselect placeholder="Seleccione un valor" v-model="select" :options="aseguradoras"
                                    label="clnombre" track-by="clclave" @select="dispatchAction">
                                </multiselect>
                            </v-col>
                            <v-col class="" cols="12" sm="6" v-if="mostrargrupo">
                                <label class="typo__label">Grupo Flotilla</label>
                                <multiselect v-model="select2" :options="grupos" placeholder="Seleccione un valor"
                                    select-label="Seleccionar valor" label="gfnombre" track-by="gfnombre"
                                    @select="dispatchAction2">
                                </multiselect>
                            </v-col>
                            <v-col class="d-flex" cols="12" sm="12">
                                <v-btn @click="Cambio()" color="success">
                                    Cambiar
                                    <v-icon right dark>
                                        mdi-account-convert
                                    </v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <!--<DatosTablero />-->
        <div v-if="showdash">
            <Sidebar @actualizarDashboard="actualizarDashboard" @bloquear="bloquear" />
            <DashboardTablero :dataTurnadoColision="dataTurnadoColision" :dataTurnadoRobo="dataTurnadoRobo"
                :dataPendientesColision="dataPendientesColision" :dataPendientesRobo="dataPendientesRobo"
                :dataVhDetenidos="dataVhDetenidos" @cambioCliente="cambioCliente" />
        </div>
    </v-container>
</template>


<script>
import { mapGetters, mapState, mapMutations } from 'vuex';
import dashboard from '@/services/dashboard/dashboard.service.js';
//import dashboard from '@/services/Dashboard/dashboard.service.js';
//import reporte from '@/services/Reporte/reporte.service.js';
import DatosTablero from '@/components/pages/main/DatosTablero.vue';
import DashboardTablero from '@/components/pages/main/Dashboard/DashboardTablero.vue';
import Inicio from '@/services/main/main.service.js';
import Sidebar from '@/components/pages/main/SidebarDashboard.vue';
import router from '@/router'
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
export default {
    components: {
        DatosTablero,
        DashboardTablero,
        Sidebar
    },
    data: () => ({
        select: [],
        select2: { gfclave: '', gfnombre: '' },
        aseguradoras: [],
        grupos: [],
        aseguradora: '',
        grupo: '',
        mostrar: false,
        mostrargrupo: false,
        clclave: '',
        gfclave: 0,
        cl: '',
        gf: '',
        cambioCli: true,
        //cambioCli: true,
        showdash: false,
        dataTurnadoColision: [],
        dataTurnadoRobo: [],
        dataPendientesColision: [],
        dataPendientesRobo: [],
        dataVhDetenidos: [],
        showcargando: true
    }),
    computed: {
        ...mapState([
            "domain",
            "informationPage",
            "paginacion",
            "permission",
            "user"
        ])
    },
    methods: {
        cambioCliente(valor) {
            this.cambioCli = valor;
        },
        VerificaPermiso(permiso) {
            Inicio.VerificarPermisos(this, permiso).then(response => {
                if (response.length > 0) {
                    this.mostrar = true;
                    this.Aseguradoras();
                }
            });
        },
        Aseguradoras() {
            Inicio.ObtenerAseguradoras(this).then(data => {
                this.aseguradoras = data;
            });
        },
        dispatchAction(valor) {
            this.clclave = valor.clclave;
            this.grupos = [];
            this.select2 = [];
            Inicio.ObtenerGrupos(this, this.clclave).then(data => {
                if (data.length > 0) {
                    this.grupos = data;
                    this.mostrargrupo = true;
                }
                else {
                    this.mostrargrupo = false;
                }
            });
        },
        dispatchAction2(valor) {
            this.gfclave = valor.gfclave;
        },
        Cambio() {
            if (this.clclave == '') {
                this.$swal({
                    position: 'center',
                    icon: 'warning',
                    title: 'Error',
                    text: 'Debe de seleccionar una aseguradora',
                    showConfirmButton: false,
                    timer: 2500
                });
            }
            else {
                let datos = {
                    clclave: this.clclave,
                    gfclave: this.gfclave
                };
                let texto = 'Se realizo el cambio de cliente a ' + this.select.clnombre;
                if (this.gfclave > 0) {
                    texto += ' grupo flotilla ' + this.select2.gfnombre
                }
                Inicio.CambiarAsegFlotilla(this, datos).then(data => {
                    this.$swal({
                        position: 'center',
                        icon: 'success',
                        title: 'Correcto',
                        text: texto,
                        showConfirmButton: false,
                        timer: 2500
                    }).then((result) => {
                        location.reload();
                    });
                });
            }
        },
        bloquear() {
            this.showcargando = true;
            this.showdash = false;
        },
        async actualizarDashboard(flotillasF, gfflotilla, valida) {
            //console.log(gfflotilla);
            this.showcargando = true;
            this.showdash = false;

            await dashboard.guardarFiltro(this, flotillasF, gfflotilla, valida).then(responsefiltro => {
                dashboard.obtenerTurnadoColisiones(this).then(response => {
                    this.dataTurnadoColision = response[0];

                    dashboard.obtenerTurnadoRobos(this).then(response1 => {
                        this.dataTurnadoRobo = response1[0];

                        dashboard.obtenerPendientesColisiones(this).then(response2 => {
                            this.dataPendientesColision = response2[0];
                            dashboard.obtenerPendientesRobos(this).then(response3 => {
                                this.dataPendientesRobo = response3[0];

                                dashboard.obtenerVhDetenidos(this).then(response4 => {

                                    Inicio.VerificarPermisos(this, 378).then(response5 => {
                                        this.showcargando = false;
                                        if (response5.length > 0) {
                                            this.dataVhDetenidos = response4[0];
                                            this.showdash = true;

                                        }
                                    });
                                });
                            });
                        });
                    });
                });
            });
        },
        cambioCliente(valor) {
            this.cambioCli = valor;
        },
        async ValidarContraseña() {
            let password = await MetodosGenerales.obtenerSessionReporte('password');
            if (password.tipo == 'PC') {
                this.$swal({
                    position: 'center',
                    icon: 'warning',
                    title: 'Aviso',
                    text: password.mensaje,
                    confirmButtonText: "De acuerdo.",
                });
            } else if (password.tipo == 'O' || password.tipo == 'N') {
                this.$router.push({ name: "perfilusuario" })
            }
        }
    },
    async mounted() {
        this.VerificaPermiso(322);
        let aux = this.$router.app._route.params.login;
        if (aux == true) { this.ValidarContraseña() }
        await dashboard.obtenerTurnadoColisiones(this).then(response => {
            this.dataTurnadoColision = response[0];

            dashboard.obtenerTurnadoRobos(this).then(response1 => {
                this.dataTurnadoRobo = response1[0];

                dashboard.obtenerPendientesColisiones(this).then(response2 => {
                    this.dataPendientesColision = response2[0];
                    dashboard.obtenerPendientesRobos(this).then(response3 => {
                        this.dataPendientesRobo = response3[0];

                        dashboard.obtenerVhDetenidos(this).then(response4 => {

                            Inicio.VerificarPermisos(this, 378).then(response5 => {
                                this.showcargando = false;
                                if (response5.length > 0) {
                                    this.dataVhDetenidos = response4[0];
                                    this.showdash = true;

                                }
                            });
                        });
                    });
                });
            });
        });
    },
}

</script>


